import React, { useState, useEffect } from "react";
import Repo from "../Utility/Repo";

const SubscriptionsSelectComponent = ({
  apiToken,
  previouslySelectedOption,
  onSelectedOptionChange,
  onIsEmpty,
}) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(
    previouslySelectedOption
  );

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await Repo.SubscriptionsSelectList(apiToken);
        if (response.status === 200) {
          const options = response.data.map((subscription) => ({
            value: subscription.value,
            label: subscription.label, // Assumi che il nome sia disponibile nel dato della sottoscrizione
          }));
          setSubscriptions(options);

          // Se previouslySelectedOption è vuoto o non definito, seleziona automaticamente il primo elemento
          if (!previouslySelectedOption && options.length > 0) {
            setSelectedOption(options[0]);
            onSelectedOptionChange(options[0]); // Richiama la funzione di callback del componente padre
            onIsEmpty(false);
          }
        }
      } catch (error) {
        onIsEmpty(true);
        console.error(
          "Errore durante il recupero delle sottoscrizioni:",
          error
        );
      }
    };

    // Chiamata al metodo per caricare i dati
    fetchSubscriptions();
  }, [previouslySelectedOption, apiToken]); // Dipendenze aggiunte

  // Funzione per gestire il cambiamento nell'opzione selezionata
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    onSelectedOptionChange(selectedOption); // Richiama la funzione di callback del componente padre
  };

  return (
    <div>
      {subscriptions.map((option) => (
        <div key={option.value} className="form-check form-check-group">
          <input
            type="radio"
            id={option.value}
            checked={
              selectedOption
                ? selectedOption.value === option.value
                : subscriptions[0].value === option.value
            }
            onChange={() => handleChange(option)}
          />
          <label htmlFor={option.value}>{option.label}</label>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionsSelectComponent;
